import React, { useState } from 'react';
import MaskedInput from 'react-text-mask';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { UserService } from '../../../../../support/services/api';
import { setAuthData } from '../../../../../support/store/AuthReducer';
import { ProcessButton, Header } from '../../../../components';



function EditUserData({
  email, firstName, setFirstName, lastName, setLastName, whatsapp, setWhatsapp, cpf, setCpf, setShowForm,
}) {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.AuthReducer.userId);
  const token = useSelector((state) => state.AuthReducer.token);
  const [localWhatsapp, setLocalWhatsapp] = useState(whatsapp.substring(3,14))

  const updateUser = async () => {
    const body = {
      firstName, lastName, whatsapp, cpf,
    };
    const response = await UserService(true).getByWhatsapp(whatsapp);
    const whatsappUnavailable = (response.length && response[0].id !== userId);

    if (whatsappUnavailable) toast('Whatsapp em uso por outro usuário.', { type: toast.TYPE.WARNING });
    else {
      UserService()
        .update({ userId, token, body })
        .then(() => {
          dispatch(setAuthData({
            firstName, lastName, email, whatsapp, cpf,
          }));
          setShowForm(false);
        });
    }
  };

  return (
      <section className="step-container">
        <Header goBack={() => setShowForm(false)} />
        <h1 className="step-title">
          Edite seus dados e confirme abaixo:
        </h1>
        <p className="step-subtitle">Salvaremos essas informações para te contactar e para futuros pedidos.</p>

        <div className="floating-label-input">
          <input disabled placeholder="E-mail" id="email" type="e-mail" name="email" value={email} onChange={() => { }} />
          <label htmlFor="email">E-mail</label>
        </div>

        <div className="step-input-group">
          <div className="floating-label-input">
            <input placeholder="Primeiro nome" id="firstName" type="text" name="firstName" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
            <label htmlFor="firstName">Primeiro nome</label>
          </div>

          <div className="floating-label-input">
            <input placeholder="Último nome" id="lastName" type="text" name="lastName" value={lastName} onChange={(e) => setLastName(e.target.value)} />
            <label htmlFor="lastName">Último nome</label>
          </div>

          <div className="floating-label-input">
            <MaskedInput
              value={localWhatsapp}
              onChange={(e) => {
                const cleaned = (`${e.target.value}`).replace(/\D/g, '');
                setWhatsapp(`+55${cleaned}`);
                setLocalWhatsapp(cleaned);
              }}
              mask={['(', /[0-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
              placeholder="Whatsapp"
              id="whatsapp"
              type="text"
              name="whatsapp"
            />
            {/* <input required placeholder="Whatsapp" id="whatsapp" type="text" name="whatsapp" value={formatPhoneNumber(whatsapp)} onChange={(e) => setWhatsapp(e.target.value)} /> */}
            <label htmlFor="whatsapp">Whatsapp</label>
          </div>

          <div className="floating-label-input">
            <MaskedInput
              value={cpf}
              onChange={(e) => {
                const cleaned = (`${e.target.value}`).replace(/\D/g, '');
                setCpf(cleaned);
              }}
              mask={[/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
              placeholder="CPF"
              id="cpf"
              type="text"
              name="cpf"
            />
            {/* <input required placeholder="Whatsapp" id="whatsapp" type="text" name="whatsapp" value={formatPhoneNumber(whatsapp)} onChange={(e) => setWhatsapp(e.target.value)} /> */}
            <label htmlFor="CPF">CPF</label>
          </div>
        </div>
        <ProcessButton text="Confirmar" action={() => updateUser()} />
      </section>
  );
}

export default EditUserData;
